import './sass/main.scss';
import './partials/js/helpers/wiki2html';
import './partials/js/helpers/jquery-isOnScreen';
import './partials/js/helper';
import './partials/js/interface';
import './partials/js/sdk';
import './partials/js/htmlOnly';
import './partials/js/webplugin';
import './partials/js/event';
import './partials/js/ui';
import './partials/js/playful';
import './partials/js/analytics';
import './partials/js/deprecated';
import './partials/js/store';
import './partials/js/demographics';
import './partials/js/sanity';
import './partials/js/screening';
import './partials/js/profiling';
import './partials/js/constants';
import './partials/js/surveyState';
import './partials/js/captcha';
import {
  renderStagingAuth,
  getAuthLocalStorage,
  checkIfStagingAndSdk,
} from './partials/js/components/StagingAuth';

// flat is load is successful
Pollfish.success = true;

// check if stylesheets are loaded
if (window.loadStylesheets === false) {
  Pollfish.success = false;
}

// init only if all libs are loaded
if (Pollfish.success) {
  // wait for everything else to load including images and then alert SDK
  $(window).load(() => {
    // Runs the function that populates Pollfish.* object with data coming from the server
    // where applicable
    Pollfish.initApi();

    $.ajaxSetup({
      beforeSend(xhr, xhrSettings) {
        const isStagingAndSdk = checkIfStagingAndSdk();
        if (isStagingAndSdk) {
          const authorization = getAuthLocalStorage();
          const authHeader =
            xhrSettings.headers && xhrSettings.headers.authorization;
          const finalAuth = authHeader || authorization;
          xhr.setRequestHeader('authorization', finalAuth);
        }
      },
    });

    // Default texts to english. Fixes issues where the getFromServer failed
    // and we didn't know which language to select.
    Pollfish.ui.texts = Pollfish.ui.getFallbackText();

    // document init is now asynchronous where it was synchronous in SDK < 19
    Pollfish.helper.document.init(() => {
      // We did not add the document.int as a callback to this render function
      // because Pollfish.helper.json is not filled with data yet
      renderStagingAuth();
      Pollfish.helper.window.init();
    });
  });
}
